import React, { useMemo, useEffect, useRef } from 'react';
import { useFocused, useReadOnly } from 'slate-react';
import schemify from 'url-schemify';
import { withTranslation } from 'react-i18next';

import { validateUrl } from '../../utils/validators';

import DocNodeWithChooser from '../doc-node-with-chooser';
import FileContainer from '../../containers/file-container';

import FieldDefault from 'components/field-default';

const DocEmbed = ({ attributes, children, element, url, menuItems, onNodeChange, onRemove, t }) => {
    const fieldRef = useRef(null);
    const readOnly = useReadOnly();

    const handleMenuAction = type => {
        onNodeChange && onNodeChange(element, type);
    }

    const handleUrlChange = url => {
        onNodeChange && onNodeChange(element, element.type, { url });
    }

    const handleRemoveClick = event => {
        event.preventDefault();
        onRemove(element);
    }

    const schemifiedUrl = useMemo(() => {
        return validateUrl(url) && schemify(url);
    }, [url]);

    useEffect(() => {
        if (!schemifiedUrl) {
            fieldRef.current && fieldRef.current.focus();
        }
    }, [schemifiedUrl]);

    const isFocused = useFocused();

    return (
        <DocNodeWithChooser current={element.type} element={attributes.ref.current} items={menuItems} depth={1} onAction={handleMenuAction}>
            <div className={'doc-node doc-media' + (isFocused ? ' focused' : '')} {...attributes}>
                <div className="doc-media-main doc-media-main-16-9">
                    <div className="doc-media-preview" contentEditable={false}>
                        {
                            !readOnly ? (
                                <button className="doc-media-remove btn btn-small btn-icon" onClick={handleRemoveClick}>
                                    <i className="ion ion-close-round" />
                                </button>
                            ) : null
                        }

                        {
                            schemifiedUrl ? (
                                <iframe src={schemifiedUrl} allow="midi; geolocation; microphone; camera; display-capture; encrypted-media;" sandbox="allow-modals allow-forms allow-scripts allow-same-origin allow-popups allow-top-navigation-by-user-activation allow-downloads" />
                            ) : (
                                <p className="info-centered">{ t('Enter valid embed URL')}</p>
                            )
                        }


                        { children }
                    </div>
                </div>

                {
                    !readOnly ? (
                        <div className="media-field" contentEditable={false}>
                            <FieldDefault provideController={fieldRef} value={url} placeholder={ t('Type embed url here') } onBlur={handleUrlChange} small={true} />

                            <button className="btn btn-success btn-small">{ t('common:Save') }</button>
                        </div>
                    ) : null
                }
            </div>
        </DocNodeWithChooser>
    )
}

export default withTranslation(['doc', 'common'])(DocEmbed);
